import html2pdf from "html2pdf.js";
import vajra_logo from "../../../../src/assets/images/vajra_logo.svg";

export const downloadReport = (reportRef, title, heading) => {
  return new Promise(async (resolve, reject) => {
    try {
      const element = reportRef.current;

      const opt = {
        margin: [25, 10, 15, 10],
        filename: title,
        html2canvas: {
          scale: 2,
          useCORS: true,
          windowWidth: 1200,
          allowTaint: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
        pagebreak: {
          mode: ["css"],
          before: ".new-page",
        },
      };
      const convertSvgToPngBase64 = (svgPath) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const pngBase64 = canvas.toDataURL("image/png");
            resolve(pngBase64);
          };
          img.src = svgPath;
        });
      };

      const logoBase64 = await convertSvgToPngBase64(vajra_logo);
      const pdf = await html2pdf().set(opt).from(element).toPdf().get("pdf");
      const totalPages = pdf.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);

        if (logoBase64) {
          const img = new Image();
          img.src = logoBase64;

          const pxToMm = 25.4 / 96;
          const logoWidth = img.width * pxToMm;
          const logoHeight = img.height * pxToMm;

          const xPosition = pdf.internal.pageSize.getWidth() - logoWidth - 45;
          const yPosition = 6;

          pdf.addImage(
            logoBase64,
            "PNG",
            xPosition,
            yPosition,
            logoWidth,
            logoHeight
          );
        }
        if (i === 1) {
          pdf.setFont("helvetica", "bold");
          pdf.setFontSize(20);
          pdf.setTextColor(0, 0, 0);
          pdf.text(heading, pdf.internal.pageSize.getWidth() / 2, 25, {
            align: "center",
          });
        }

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(10);
        pdf.setTextColor(0, 0, 0);
        pdf.text(
          `Page ${i} of ${totalPages}`,
          pdf.internal.pageSize.getWidth() / 2,
          pdf.internal.pageSize.getHeight() - 10,
          { align: "center" }
        );
      }
      await pdf.save(title);
      resolve();
    } catch (err) {
      reject(err);
    }
  });
};